// src/frontend/data/books/FundamentosBlockchain/resumenFundamentosBlockchain.ts
const RESUMEN_BLOCKCHAIN = {
  title: "Fundamentos de Blockchain",
  sections: [
    {
      id: "resumen",
      heading: "Resumen del Libro",
      text: `En este libro se explican las bases fundamentales y los pilares esenciales de la tecnología Blockchain,
una innovación que hoy está presente en diversos ámbitos de la vida cotidiana.

A lo largo de sus páginas, se presentan de forma clara y progresiva los principios que sostienen la descentralización,
el registro distribuido y los mecanismos que garantizan la transparencia e inmutabilidad de los datos.

El lector encontrará explicaciones accesibles sobre la estructura de la cadena de bloques, 
el encadenamiento de transacciones mediante funciones hash y la manera en que se elimina la necesidad de intermediarios
para establecer confianza.

También se introducen los conceptos esenciales de criptografía aplicada —incluyendo el uso de claves públicas y privadas— 
que permiten que las transacciones sean verificables y seguras en toda la red.

Finalmente, se ofrece una visión inicial de los contratos inteligentes (Smart Contracts) y su rol dentro del ecosistema Ethereum,
abriendo camino a la comprensión de aplicaciones descentralizadas y del futuro de la economía digital.`,
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/img1.png",
        alt: "Criptoactivos representativos (Bitcoin y altcoins)",
        caption: "Representación de criptoactivos en un ecosistema blockchain."
      },
      subsections: [
        {
          id: "proposito",
          heading: "Propósito",
          text: `Brindar una visión clara de cómo funciona Blockchain, su relevancia en el mundo actual 
y cómo sus fundamentos permiten el desarrollo de soluciones seguras, trazables y descentralizadas.`
        }
      ]
    },

    {
      id: "enfoque",
      heading: "¿Qué cubrimos?",
      text: [
        "• Fundamentos conceptuales: bloques, hash, consenso e inmutabilidad.",
        "• Principios básicos de criptografía aplicada a la cadena de bloques.",
        "• Explicación del registro distribuido y eliminación de intermediarios.",
        "• Introducción a los contratos inteligentes y al ecosistema Ethereum."
      ],
      subsections: [
        {
          id: "inmutabilidad",
          heading: "Inmutabilidad y registro histórico",
          text: `La inmutabilidad garantiza que los datos confirmados no se modifican;
cualquier cambio requiere una nueva transacción que amplía la cadena, preservando así el registro histórico.`,
          image: {
            src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/cap1_2.png",
            alt: "Esquema de inmutabilidad",
            caption: "Los cambios se añaden mediante nuevas transacciones"
          },
        },
        {
          id: "consenso",
          heading: "Consenso: PoW y PoS",
          text: `Los mecanismos de consenso coordinan a los participantes para acordar el estado válido de la red.
PoW (Prueba de Trabajo) y PoS (Prueba de Participación) son los modelos más representativos en la actualidad.`
        }
      ]
    },

   

    {
      id: "imagen-intermedia",
      heading: "Estructura de un Bloque ",
      type: "image",
      src: "https://github.com/prabeshdulal/100DaysOfLearningBlockchain/assets/138851338/335542d9-7c6e-4684-aacc-55ee8a3e10f8",
      alt: "Estructura de un bloque con cabecera y cuerpo",
      caption: "Un bloque contiene una cabecera (hash previo, timestamp, nonce, etc.) y un cuerpo con las transacciones."
    },

    {
      id: "cierre",
      heading: "Objetivo Final",
      text: `Al finalizar, el lector contará con una base sólida para comprender el funcionamiento de Blockchain,
sus aplicaciones y la forma en que esta tecnología impulsa la evolución del ecosistema digital.`,
      subsections: [
        {
          id: "siguientes-pasos",
          heading: "Siguientes pasos recomendados",
          list: [
            "Repasar los principios de hashing, firmas digitales y árboles de Merkle.",
            "Explorar herramientas de desarrollo para entender cómo se implementan contratos inteligentes.",
            "Analizar casos de uso reales donde Blockchain mejora la trazabilidad y la confianza.",
            "Investigar las tendencias del ecosistema Web3 y sus aplicaciones descentralizadas."
          ]
        }
      ]
    }
  ]
};

export default RESUMEN_BLOCKCHAIN;
